import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationStart, NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {ContentService, ContentStateService, KeyboardService} from './services';
import {routerFadeSlideFromLeftTransition} from './router.animations';
import {NavItem} from './model/typings/nav.types';
import {ContentDetail, ContentDetailMessage} from './model/typings/content.types';

@Component({
  selector: 'cpui-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routerFadeSlideFromLeftTransition]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'CPUI Consulting';
  activeNavState: string;
  activeContentDetailMessage: ContentDetailMessage;
  subNavList: NavItem[];
  private keyupSubscription: Subscription;
  private activeSubNavItemsSubscription: Subscription;
  private messageContentDetailSubscription: Subscription;
  private routerEventSubscription: Subscription;

  constructor(private contentService: ContentService,
              private contentStateService: ContentStateService,
              private keyboardService: KeyboardService,
              private router: Router) {

  }

  ngOnInit() {
    this.activeSubNavItemsSubscription = this.contentStateService
      .activeSubNavListObservable.subscribe(navItems => this.onUpdatedSubNavList(navItems));

    this.messageContentDetailSubscription = this.contentStateService
      .activeMessageContentDetailObservable.subscribe(contentDetailMessage =>
        this.onActiveMessageContentDetailUpdate(contentDetailMessage));

    this.routerEventSubscription = this.router.events.subscribe((event) => this.onRouterEvent(event));

    this.keyupSubscription = this.keyboardService.onDocumentKeyupObservable().subscribe((event) => this.onDocumentKeyup(event));
  }

  ngOnDestroy() {
    if (this.activeSubNavItemsSubscription) {
      this.activeSubNavItemsSubscription.unsubscribe();
    }
    if (this.messageContentDetailSubscription) {
      this.messageContentDetailSubscription.unsubscribe();
    }
    if (this.routerEventSubscription) {
      this.routerEventSubscription.unsubscribe();
    }
  }

  onMessageContentDetailClose(messageContentDetail: ContentDetail): void {
    console.log(`CPUI - AppComponent.onMessageContentDetailClose()`, messageContentDetail);
    this.clearMessageContentDetail();
  }

  clearMessageContentDetail(): void {
    this.contentStateService.setActiveMessageContentDetail(null);
  }

  onActiveMessageContentDetailUpdate(contentDetailMessage: ContentDetailMessage) {
    console.log(`CPUI - AppComponent.onActiveMessageContentDetailUpdate()`, contentDetailMessage);
    this.activeContentDetailMessage = contentDetailMessage;
  }

  onDocumentKeyup(keyupEvent: KeyboardEvent): void {
    const isEscape = (keyupEvent.key === 'Escape' || keyupEvent.key === 'Esc');

    if (isEscape) {
      console.log(`CPUI - AppComponent.onDocumentKeyup() ESCAPE`, keyupEvent, this.activeNavState);

      this.clearMessageContentDetail();
    }
  }

  onRouterEvent(event) {
    if (event instanceof NavigationStart) {
      console.log(`CPUI - AppComponent.onRouterEvent() NavigationStart`, event);
      this.clearMessageContentDetail();
    }
    if (event instanceof NavigationEnd) {
      console.log(`CPUI - AppComponent.onRouterEvent() NavigationEnd`, event);
      this.activeNavState = event.urlAfterRedirects || '';
    }
  }

  onUpdatedSubNavList(navItems: NavItem[]) {
    console.log(`CPUI - AppComponent.onUpdatedSubNavList()`, navItems);
    this.subNavList = navItems;
  }

  isSubNavBlurred(): boolean {
    const navState = this.activeNavState;
    const blurredNavRoutes: Array<string> = ['/home/U', '/home/inspire', '/home/component',
      '/home/product', '/home/user', '/home/interface'];
    return navState && blurredNavRoutes.includes(navState);
  }

  isMobileSubNavBlurred(): boolean {
    const navState = this.activeNavState;
    const blurredNavRoutes: Array<string> = ['/home/C', '/home/inspire', '/home/P', '/home/U',
      '/home/I', '/home/component', '/home/product', '/home/user',
      '/home/interface'];
    return navState && blurredNavRoutes.includes(navState);
  }

  getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts